import {SearchResults} from './searchResults';
import {ResourceSearchResult} from '../model/resourceSearchResult';

export const ResourcesSearchResults = SearchResults.extend({
    _name: 'Resources',
    model: ResourceSearchResult,
    url: '/resources',
});
